import {Button} from '@mui/material'
import Loadable from 'shared/Loadable'
import React, {lazy} from 'react'
import './index.scss'

const CircularProgress = Loadable(lazy(async () => await import('@mui/material/CircularProgress')))

interface GradientButtonProps {
    isLoading?: boolean
    disabled?: boolean
    text?: string
    result?: boolean
    onHandleClick?: any
}

const GradientButton = (props: GradientButtonProps) => {
    const {isLoading, disabled, text, onHandleClick} = props

    // Commented: This part of code is related to booking screens
    // as booking is not required, commenting the following code.

    // const getTitle = () => {
    //     if (!disabled) return ''
    //     // eslint-disable-next-line quotes
    //     else return "Please review 'Routing & Price' details to continue with Create / Modify Booking"
    // }

    return (
        <>
            <div
                className='gradientButtonWrapper'
                // title={getTitle()}
            >
                <Button
                    onClick={onHandleClick}
                    variant='outlined'
                    className='loginSubmit-btn'
                    type='submit'
                    disabled={isLoading ?? disabled}
                >
                    {isLoading ? (
                        <CircularProgress size={24} className='loginSubmit-btn-progress' />
                    ) : (
                        <span>{text ?? 'Send code to email'}</span>
                    )}
                </Button>
            </div>
        </>
    )
}

GradientButton.defaultProps = {
    isLoading: false,
    disabled: false,
    text: 'Send code to email',
    onHandleClick: () => {}
}

export default GradientButton
